import Component from "./DefaultGameCard";

export default Component;
